import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';

import { gameTypes } from 'config/promoGameTypes';
import { utcDTStr2LocalDTStr } from 'utils/dateTime';
import SerialDateInfo from 'client/components/Result/EntriesInfo/SerialDateInfo';

function EntryList({ items = [], gameType, needShowFormBtn = false }) {
    const { id: signUpFormId } = useSelector(s => s.signUpForm);
    const { formId: gameFormId } = useSelector(s => s.settingGame);

    // 根據 id 降序排序
    const sortedItems = [...items].sort((a, b) => b.id - a.id);

    return sortedItems.map(item => {
        const {
            flow: { gameResult: gameResultCreatedAt, formSignUp } = {},
            id,
            uuid: entryUuid
        } = item;

        const resultCreatedAt = Boolean(gameResultCreatedAt)
            ? dayjs(utcDTStr2LocalDTStr(gameResultCreatedAt)).format('YYYY-MM-DD HH:mm')
            : 'YYYY-MM-DD HH:mm';

        const showFormBtn =
            needShowFormBtn &&
            ((gameType === gameTypes.SURVEY && gameResultCreatedAt) || Boolean(formSignUp));

        const formIds = {
            gameFormId: gameType === gameTypes.SURVEY && gameResultCreatedAt ? gameFormId : null,
            signUpFormId
        };

        return (
            <div key={id}>
                <SerialDateInfo
                    id={id}
                    date={resultCreatedAt}
                    showFormBtn={Boolean(showFormBtn)}
                    formIds={formIds}
                    entryUuid={entryUuid}
                />
            </div>
        );
    });
}

EntryList.propTypes = {
    items: PropTypes.array,
    gameType: PropTypes.number,
    needShowFormBtn: PropTypes.bool
};

export default EntryList;
